import classNames from 'classnames'
import * as React from 'react'
import { CartesianGrid as RechartsCartesianGrid } from 'recharts'

import { CARTESIAN_STROKE } from './constants'

export function CartesianGrid({
  vertical = false,
  ...props
}: React.PropsWithoutRef<React.ComponentProps<typeof RechartsCartesianGrid>>) {
  return (
    <RechartsCartesianGrid
      {...props}
      vertical={vertical}
      stroke={null as any} // Types don’t allow null
      strokeDasharray="3 3"
      className={classNames(props.className, CARTESIAN_STROKE)}
    />
  )
}

CartesianGrid.displayName = RechartsCartesianGrid.displayName
